// extracted by mini-css-extract-plugin
export default {"main":"chatMessageForm_main__Yu7Ak","form":"chatMessageForm_form__otLct"};